var _defs, _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSarawak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 1200,
    height: 600,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs348"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "rect3",
    strokeWidth: 1,
    d: "M0 0h1200v600H0z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style333"
  }, ".st0{fill:#fcd116}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g343"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "rect335",
    strokeWidth: 1,
    d: "M0 0h1200v600H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-100v300l1200 600V500Z",
    id: "path339",
    clipPath: "url(#clipPath3)",
    strokeWidth: 1,
    fill: "#ce1126"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon337",
    d: "M600 300V200L200 0H0Z",
    transform: "scale(2)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "g7",
    transform: "rotate(16.57 615.5352 302.2615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m600 154.523-20.5212 93.6185-18.046 102.3442-12.7358 94.9913L600 364.523l51.303 80.954-12.7357-94.9913-18.046-102.3442z",
    id: "path4",
    fill: "#fcd116",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#path4",
    id: "use6",
    transform: "rotate(80 600 304.523)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.5818 189.6164 44.4567 84.9066 90.5288 75.9627 91.3365 29.0374-70.8153-64.5812-7.127-40.4189 44.4567-84.9066-75.897 58.525h-41.0424z",
    id: "path7",
    fill: "#fcd116",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSarawak);
export default __webpack_public_path__ + "static/media/sarawak.b349a00523ab9aa9d9effb9a21eeb0e0.svg";
export { ForwardRef as ReactComponent };